import { AiApiService } from "./ai.api.service";

export function provideAiApi() {
    return [AiApiService];
}
